
export default "/assets/arrow-path-rounded-square-micro.7686d1d9.svg"